import { useEffect, useState } from 'react';
import { ManualLegDto } from '../../../types';
import ManualLegsForm from './manualLegsForm';
import { useSnackbar } from 'notistack';
import { useShipForm } from '../../../context/shipForms';
import MainBusinessPaymentPage from '../../shipment/business-central';
import { BCPlanningLinesInitialValue } from '../../../initial-values';
import { formatDateWithDashes } from '../../../utils/helper';

interface Props {
  setShowLegsForm: any;
  setCurrentShipmentStatus: any;
}
function ManualShipmentLegs({
  setShowLegsForm,
  setCurrentShipmentStatus,
}: Props) {
  const { setSelectedManualLegsContext, setSelectedPlanningLaneContext } =
    useShipForm();
  const { enqueueSnackbar } = useSnackbar();
  const [manualLegList, setManualLegList] = useState<ManualLegDto[]>([]);
  const [validating, setValidating] = useState(false);
  const [showBCScreen, setShowBCScreen] = useState(false);

  function handleBack() {
    setCurrentShipmentStatus('packages');
    setShowLegsForm(false);
  }
  function isValidationValidated(legValidations: boolean[]): boolean {
    return Object.values(legValidations).every(
      (validation: boolean) => validation
    );
  }
  function handleNext() {
    if (!manualLegList || manualLegList.length === 0) {
      enqueueSnackbar('Please add atleast one leg.', { variant: 'error' });
      return;
    }
    setValidating(true);
    const allLegsValidated = manualLegList.every((item: ManualLegDto) =>
      isValidationValidated(item.legValidations)
    );
    if (!allLegsValidated) {
      enqueueSnackbar('Please provide all required fields.', {
        variant: 'error',
      });
      return;
    }

    setPlanningLines();
  }
  function setPlanningLines() {
    let mainPlanning: any = [];

    manualLegList.forEach((item: ManualLegDto, index: number) => {
      let planningLine = {
        leg: `L${index + 1}`,
        carrier_id: item.carrier_code,
        line_type: '3',
        item: 'TRANSPORTATION',
        markup: '',
        branch_code: 130,
        cost_centre: '210',
        location_code: 'YEGFF',
      };
      mainPlanning.push(planningLine);
      setSelectedPlanningLaneContext([
        ...mainPlanning,
        ...BCPlanningLinesInitialValue,
      ]);
      if (mainPlanning.length === manualLegList.length) {
        manualLegList.forEach((item: ManualLegDto) => {
          delete item.carrier_id;
          delete item.legValidations;
          item.estimated_delivery_date = formatDateWithDashes(
            new Date(item.estimated_delivery_date)
          );
        });
        setSelectedManualLegsContext(manualLegList);
        setShowBCScreen(true);
      }
    });
  }
  return (
    <>
      {showBCScreen ? (
        <MainBusinessPaymentPage
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setShowBCScreen={setShowBCScreen}
          setShowLegsForm={setShowLegsForm}
          isManualLegs={true}
        />
      ) : (
        <>
          <ManualLegsForm
            manualLegList={manualLegList}
            setManualLegList={setManualLegList}
            validating={validating}
          />

          <div className='row mt-5 pt-5'>
            <div className='col-4 col-lg-2'>
              <p
                className='btn btn-ubbe-new-back d-flex gap-2'
                onClick={handleBack}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='15'
                  height='8'
                  viewBox='0 0 15 8'
                  fill='none'
                >
                  <path
                    d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                    fill='black'
                  />
                </svg>
                Back
              </p>
            </div>
            <div className='col-4 col-lg-8'></div>
            {manualLegList?.length ? (
              <div className='col-3 col-lg-2 text-end d-flex  align-items-end justify-content-end '>
                <p
                  className='btn-ubbe-new-blue  text-end d-lg-flex  justify-content-end '
                  onClick={handleNext}
                  style={{ maxWidth: '145px', cursor: 'pointer' }}
                >
                  Continue
                </p>
              </div>
            ) : (
              ''
            )}
          </div>
        </>
      )}
    </>
  );
}

export default ManualShipmentLegs;
